import { useNavigate } from "react-router-dom";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div style={pageWrapper}>
      {/* Header */}
      <header style={header}>
        <div style={headerContent}>
          <h1 style={logo} onClick={() => navigate("/")}>Adsoar</h1>
          <button style={backButton} onClick={() => navigate("/")}>
            ← Back to Home
          </button>
        </div>
      </header>

      {/* Content */}
      <div style={contentWrapper}>
        <div style={titleSection}>
          <h1 style={mainTitle}>Privacy Policy</h1>
          <p style={effectiveDate}>Effective Date: August 29th, 2025</p>
        </div>

        <div style={content}>
          <p style={intro}>
            Adsoar LLC ("we," "our," or "us") values your privacy. This Privacy Policy explains what information we collect, how we use it, and your rights regarding your data when you use our app.
          </p>

          <section style={section}>
            <h2 style={sectionTitle}>1. Information We Collect</h2>
            <p style={paragraph}>We may collect the following information from you:</p>
            <ul style={list}>
              <li style={listItem}>Your name, email address, and Facebook account information when you log in.</li>
              <li style={listItem}>Ad account information and campaign performance data to run and manage ads on your behalf.</li>
              <li style={listItem}>Analytics and performance data related to the ads created using Adsoar LLC.</li>
            </ul>
          </section>

          <section style={section}>
            <h2 style={sectionTitle}>2. How We Use Your Information</h2>
            <p style={paragraph}>We use your data to:</p>
            <ul style={list}>
              <li style={listItem}>Authenticate your account and log you into the app.</li>
              <li style={listItem}>Create, manage, and optimize your ad campaigns.</li>
              <li style={listItem}>Provide analytics and reporting features within the app.</li>
              <li style={listItem}>Communicate important updates and support messages.</li>
            </ul>
          </section>

          <section style={section}>
            <h2 style={sectionTitle}>3. Sharing Your Information</h2>
            <p style={paragraph}>We do not sell your information. Your data may be shared only as needed to:</p>
            <ul style={list}>
              <li style={listItem}>Facebook/Meta platforms to run ads and access audience data.</li>
              <li style={listItem}>Comply with legal obligations or protect our rights.</li>
            </ul>
          </section>

          <section style={section}>
            <h2 style={sectionTitle}>4. Your Rights</h2>
            <p style={paragraph}>You have the right to:</p>
            <ul style={list}>
              <li style={listItem}>Access the data we have about you.</li>
              <li style={listItem}>Request correction or deletion of your data.</li>
              <li style={listItem}>Opt-out of communications or revoke app permissions from your Facebook settings.</li>
            </ul>
          </section>

          <section style={section}>
            <h2 style={sectionTitle}>5. Data Retention</h2>
            <p style={paragraph}>
              We retain your data only as long as necessary to provide our services or comply with legal requirements.
            </p>
          </section>

          <section style={section}>
            <h2 style={sectionTitle}>6. Contact Us</h2>
            <p style={paragraph}>
              If you have questions or concerns about this Privacy Policy or your data, please contact us at:
            </p>
            <p style={contactInfo}>
              <strong>Email:</strong> <a href="mailto:matthew@adsoar.cc" style={link}>matthew@adsoar.cc</a>
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer style={footer}>
        <p>&copy; {new Date().getFullYear()} Adsoar LLC. All rights reserved.</p>
      </footer>
    </div>
  );
};

/* Styles */
const pageWrapper = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  background: "#f8fafc",
};

const header = {
  background: "white",
  borderBottom: "1px solid #e2e8f0",
  padding: "20px 0",
  position: "sticky",
  top: 0,
  zIndex: 100,
};

const headerContent = {
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "0 24px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const logo = {
  fontSize: "1.5rem",
  fontWeight: 800,
  background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  cursor: "pointer",
  margin: 0,
};

const backButton = {
  background: "transparent",
  border: "1px solid #e2e8f0",
  color: "#64748b",
  padding: "10px 20px",
  borderRadius: "8px",
  fontSize: "0.95rem",
  fontWeight: 500,
  cursor: "pointer",
  transition: "all 0.2s",
};

const contentWrapper = {
  flex: 1,
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 24px",
  width: "100%",
};

const titleSection = {
  marginBottom: "48px",
  textAlign: "center",
};

const mainTitle = {
  fontSize: "3rem",
  fontWeight: 800,
  color: "#0f172a",
  marginBottom: "16px",
  letterSpacing: "-0.02em",
};

const effectiveDate = {
  fontSize: "1.1rem",
  color: "#64748b",
  fontWeight: 500,
};

const content = {
  background: "white",
  borderRadius: "16px",
  padding: "48px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  border: "1px solid #e2e8f0",
};

const intro = {
  fontSize: "1.1rem",
  lineHeight: "1.8",
  color: "#475569",
  marginBottom: "40px",
};

const section = {
  marginBottom: "40px",
};

const sectionTitle = {
  fontSize: "1.5rem",
  fontWeight: 700,
  color: "#0f172a",
  marginBottom: "16px",
};

const paragraph = {
  fontSize: "1.05rem",
  lineHeight: "1.8",
  color: "#475569",
  marginBottom: "12px",
};

const list = {
  listStyleType: "disc",
  paddingLeft: "24px",
  marginTop: "12px",
};

const listItem = {
  fontSize: "1.05rem",
  lineHeight: "1.8",
  color: "#475569",
  marginBottom: "8px",
};

const contactInfo = {
  fontSize: "1.05rem",
  lineHeight: "1.8",
  color: "#475569",
  marginTop: "12px",
};

const link = {
  color: "#6366f1",
  textDecoration: "none",
  fontWeight: 600,
};

const footer = {
  background: "white",
  borderTop: "1px solid #e2e8f0",
  padding: "32px 24px",
  textAlign: "center",
  color: "#64748b",
  fontSize: "0.95rem",
};

export default PrivacyPolicyPage;
